import React from 'react';
import StatCard from '../shared/StatCard';

export const ModelStudioStats = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <StatCard
        title="Training Jobs"
        value={stats.training_jobs_active || 0}
        subtitle="active"
      />
      
      <StatCard
        title="Model Versions"
        value={stats.model_versions_deployed || 0}
        subtitle="deployed"
      />
      
      <StatCard
        title="Active Pipelines"
        value={`${stats.active_pipelines || 0} out of ${stats.total_pipelines || 0}`}
        subtitle="running"
      />
      
      <StatCard
        title="Avg Performance"
        value={`${(stats.avg_performance || 0).toFixed(0)}%`}
        subtitle="F1-Score"
      />
    </div>
  );
};

export default ModelStudioStats;
